import { render, staticRenderFns } from "./cementMortar.vue?vue&type=template&id=21254418&scoped=true"
import script from "./cementMortar.vue?vue&type=script&lang=js"
export * from "./cementMortar.vue?vue&type=script&lang=js"
import style0 from "./cementMortar.vue?vue&type=style&index=0&id=21254418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21254418",
  null
  
)

export default component.exports